var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconSeekForward = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9.558 9.32c.589.376.59.985 0 1.362L3.066 14.83c-.589.377-1.066.105-1.066-.593V5.765c0-.704.476-.97 1.066-.594zm9 0c.589.376.59.985 0 1.362l-6.492 4.148c-.589.377-1.066.105-1.066-.593V5.765c0-.704.476-.97 1.066-.594z"
})));
export default SvgIconSeekForward;